export class Synonym {
    id: number = 0;
    group_id: number = 0;
    synonym_phrase: string = '';
    normalized_phrase: string = '';
    word_count: number = 0;
    group?: SynonymGroup;
}

export class SynonymGroup {
    id: number = 0;
    group_name: string = '';
    is_active: number = 1;
    synonyms?: Synonym[] = [];
}
